import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { endAnimation } from '../store/slices/animationSlice';

function PassAnimation() {
  const dispatch = useDispatch();
  const { isAnimating, startPosition, endPosition, imageSrc } = useSelector(
    (state) => state.animation
  );
  const [position, setPosition] = useState(startPosition);

  useEffect(() => {
    if (isAnimating) {
      console.log("PassAnimation - Start Position:", startPosition);
      console.log("PassAnimation - End Position:", endPosition);
      setPosition(startPosition);
      const timeout = setTimeout(() => {
        setPosition(endPosition);
      }, 50); // Start animation shortly after render

      const animationDuration = 2000; // ms
      const endTimeout = setTimeout(() => {
        dispatch(endAnimation());
      }, animationDuration);

      return () => {
        clearTimeout(timeout);
        clearTimeout(endTimeout);
      };
    }
  }, [isAnimating, startPosition, endPosition, dispatch]);

  if (!isAnimating) {
    return null;
  }

  return (
    <div
      style={{
        position: 'fixed',
        left: position.x,
        top: position.y,
        width: '100px', // Adjust size as needed
        height: 'auto',
        transition: 'left 2s ease-in-out, top 2s ease-in-out, opacity 0.5s ease-in-out 1.5s',
        opacity: 1,
        zIndex: 10000,
      }}
    >
      <img src={imageSrc} alt="pass" style={{ width: '100%', height: 'auto' }} />
    </div>
  );
}

export default PassAnimation;
